import { COLORS } from '../constants/theme';
import type { ProvinceEventSeverity } from '../types/provinceEvents';

/**
 * SF-123 Decision 8: severity paired with a glyph, never color alone (WCAG 1.4.1, SF-181
 * precedent). Shared by both the Throne Room card (`IncomingActivitySection.tsx`) and the browse
 * page (`ProvinceEventFeed.tsx`) so the two surfaces can never silently drift on how a given
 * event is styled.
 */
export const SEVERITY_STYLE: Record<ProvinceEventSeverity, { color: string; glyph: string }> = {
  CRITICAL: { color: COLORS.negative, glyph: '✖' },
  NOTABLE: { color: COLORS.warning, glyph: '⚠' },
  MINOR: { color: COLORS.positive, glyph: '✓' },
};
